(() => {
  const touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');
  const cardSelector = '.oqera-native-card, .oqera-living__card, .oqera-all-products__card, .oqera-favorites__card, product-card';
  const mediaSelector = '.oqera-native-card__media, .oqera-living__media, .oqera-all-products__media, .oqera-favorites__image-link, .card-gallery';
  let activeCard = null;
  const reset = (card) => {
    if (!card) return;
    card.classList.remove('oqera-touch-preview');
    card.querySelectorAll('[data-oqera-touch-image]').forEach((image) => {
      ['opacity','position','inset','width','height','object-fit','z-index','pointer-events'].forEach((name) => image.style.removeProperty(name));
      image.removeAttribute('data-oqera-touch-image');
    });
    card.querySelectorAll('[data-oqera-touch-slide]').forEach((slide) => {
      ['opacity','position','inset','transform','visibility','z-index','display'].forEach((name) => slide.style.removeProperty(name));
      slide.removeAttribute('data-oqera-touch-slide');
    });
  };
  const preview = (card) => {
    const media = card.querySelector(mediaSelector);
    if (!media) return false;
    const images = [...media.querySelectorAll('img')].filter((image) => image.currentSrc || image.src);
    if (images.length < 2) return false;
    const first = images[0];
    const second = images[1];
    first.setAttribute('data-oqera-touch-image', '');
    second.setAttribute('data-oqera-touch-image', '');
    first.style.opacity = '0';
    Object.assign(second.style, { opacity:'1', position:'absolute', inset:'0', width:'100%', height:'100%', objectFit:'contain', zIndex:'1', pointerEvents:'none' });
    const firstSlide = first.closest('slideshow-slide');
    const secondSlide = second.closest('slideshow-slide');
    if (firstSlide && secondSlide) {
      firstSlide.setAttribute('data-oqera-touch-slide', '');
      secondSlide.setAttribute('data-oqera-touch-slide', '');
      firstSlide.style.opacity = '0';
      Object.assign(secondSlide.style, { position:'absolute', inset:'0', transform:'none', visibility:'visible', opacity:'1', zIndex:'1', display:'block' });
    }
    card.classList.add('oqera-touch-preview');
    return true;
  };
  document.addEventListener('click', (event) => {
    if (!touchQuery.matches) return;
    const link = event.target.closest('a[href]');
    const card = event.target.closest(cardSelector);
    if (!link || !card) {
      reset(activeCard);
      activeCard = null;
      return;
    }
    if (card === activeCard && card.classList.contains('oqera-touch-preview')) return;
    reset(activeCard);
    activeCard = null;
    if (preview(card)) {
      event.preventDefault();
      event.stopPropagation();
      activeCard = card;
    }
  }, true);
})();